// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn--85gXj"};